<template>
  <div class="auto" v-loading="loading">
    <div class="action" v-if="actionBar">
      <el-button class="WEB-button WEB-button-alternative" v-if="trasferta.terminata !== 'T'" @click="add">{{
        $t('btn.add').toUpperCase() }}</el-button>
    </div>
    <div style="marginTop:25px" v-else></div>
    <el-table :data="auto" @row-click="open" :empty-text="$t('auto.msg.noData')" :row-class-name="tableRowClassName"
      class="custom-table">
      <el-table-column header-align="center" align="center" width="50">

        <template slot-scope="scope" slot="header">
          <div class="icon-title">
            <el-popover placement="top" v-model="visibleInfo" :key="scope.toString()">
              <div>
                <div>
                  <icon name="riv-circle" class="status-saved" scale="0.8"></icon>
                  <span>{{ $t('statusDett.0') }}</span>
                </div>
                <div>
                  <icon name="riv-circle" class="status-send" scale="0.8"></icon>
                  <span>{{ $t('statusDett.1') }}</span>
                </div>
                <div>
                  <icon name="riv-circle" class="status-rejected" scale="0.8"></icon>
                  <span>{{ $t('statusDett.2') }}</span>
                </div>
                <div>
                  <icon name="riv-circle" class="status-approved" scale="0.8"></icon>
                  <span>{{ $t('statusDett.3') }}</span>
                </div>
              </div>

              <span slot="reference">
                <icon class="pointer" name="riv-help" scale="1"></icon>
              </span>
            </el-popover>

          </div>
        </template>

        <template slot-scope="scope">
          <div class="data-wrapper">
            <el-tooltip v-if="scope.row.id !== ''" class="item" effect="dark"
              :content="$t('statusDett.' + scope.row.statoAvanz)" placement="top-start">
              <icon :name="getStatoIcon_dett(scope.row.statoAvanz)" :class="getStatoClass_dett(scope.row.statoAvanz)"
                scale="0.8"></icon>
            </el-tooltip>
          </div>
        </template>

      </el-table-column>
      <el-table-column header-align="center" align="center" :label="$t('auto.label.giorno')" width="100">

        <template slot-scope="scope">
          <div class="data-wrapper">
            {{ scope.row.giorno | formattaData }}
          </div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" :label="$t('auto.label.orario')" width="100">

        <template slot-scope="scope">
          <div v-if="scope.row.id !== ''" class="data-wrapper">
            {{ scope.row.oraDal | formattaHours }} / {{ scope.row.oraAl | formattaHours }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="desLuogoRitiro" :label="$t('auto.label.ritiro')" min-width="200">
      </el-table-column>



      <el-table-column header-align="center" align="center" :label="$t('auto.label.utilizzo')" min-width="400">

        <template slot-scope="scope">
          <div class="data-wrapper">
            {{ scope.row.utilizzo.replace(/\\n|\\r\\n|\\n\\r|\\r/g, ' ') }}
          </div>
        </template>
      </el-table-column>

      <el-table-column width="50">

        <template slot-scope="scope" slot="header">
          <div class="icon-title">
            <el-tooltip class="item" effect="dark" :content="$t('auto.label.telepass')" placement="top-start"
              :key="scope.toString()">
              <icon name="riv-telepass" scale="1.2"></icon>
            </el-tooltip>
          </div>
        </template>

        <template slot-scope="scope">
          <div class="data-wrapper">
            <icon v-if="scope.row.telepass === '1'" name="riv-tick" scale="1.2"></icon>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="50">

        <template slot-scope="scope" slot="header">
          <div class="icon-title">
            <el-tooltip class="item" effect="dark" :content="$t('auto.label.navigator')" placement="top-start"
              :key="scope.toString()">
              <icon name="riv-navigatore" scale="1.2"></icon>
            </el-tooltip>
          </div>
        </template>

        <template slot-scope="scope">
          <div class="data-wrapper">
            <icon v-if="scope.row.navigatore === '1'" name="riv-tick" scale="1.2"></icon>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="50" v-if="enableAction('del')">

        <template slot-scope="scope">
          <div class="actions">
            <icon name="riv-delete2" scale="1.2" @click.native.stop="del(scope.row)"></icon>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="(nrPages > 1)" :current-page="currentPage" class="custom-pagination" background
      layout="prev, pager, next" :total="nrItems" :page-size="pag_for" @current-change="changePage">
    </el-pagination>

    <!-- Dialog di creazione di una nuova richiesta di ferie -->
    <el-dialog :title="($t('auto.label.title').toUpperCase())" :visible.sync="showModal" class="custom-dialog"
      :append-to-body="true" custom-class="offset-5 col-14">

      <el-form class="" :disabled="trasferta.terminata === 'T' || !actionBar">
        <div class="elemento row row-custom" v-if="form.id !== ''">
          <div class="my-label col-8 no-padding">
            {{ $t('auto.label.giorno') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-select v-model="form.giorno">
              <el-option v-for="item in picker_days" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="elemento row row-custom" v-if="form.id === ''">
          <div class="my-label col-8 no-padding">
            {{ $t('auto.label.dataDal') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-select v-model="form.dataDal">
              <el-option v-for="item in picker_days" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select> 
          </div>
        </div>
        <div class="elemento row row-custom" v-if="form.id === ''">
          <div class="my-label col-8 no-padding">
            {{ $t('auto.label.dataAl') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-select v-model="form.dataAl">
              <el-option v-for="item in picker_days" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select> 
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaAuto && (this.form.oraDal === undefined || this.form.oraDal === null || this.form.oraAl === undefined || this.form.oraAl === null) ? 'row-error' : '']">
          <div class="my-label col-8 no-padding">
            {{ $t('auto.label.orario') + ' (*)' }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-time-picker v-model="form.oraDal" format="HH:mm" :placeholder="$t('auto.label.inizio')"
              value-format="HH:mm">
            </el-time-picker>
            <el-time-picker v-model="form.oraAl" format="HH:mm" :placeholder="$t('auto.label.fine')"
              value-format="HH:mm">
            </el-time-picker>
            <!--<el-time-select class="dt-picker time"
                            v-model="form.oraDal"
                            placeholder="Select time"
                            :picker-options="{start: '00:00',step: '00:15',end: '24:00', format:'HH:mm'}">
            </el-time-select>
            <el-time-select class="dt-picker time"
                            v-model="form.oraAl"
                            placeholder="Select time"
                            :picker-options="{start: form.oraDal,step: '00:15',end: '24:00', format:'HH:mm'}">
            </el-time-select>-->
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaAuto && (this.form.luogoRitiro === undefined || this.form.luogoRitiro === '') ? 'row-error' : '']">
          <div class="my-label col-8 no-padding">
            {{ $t('auto.label.ritiro') + ' (*)' }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-select v-model="form.luogoRitiro">
              <el-option v-for="item in tbl_genSta" :key="item.id" :label="item.desc" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('auto.label.utilizzo') }}
          </div>
          <div class="my-value col-16 no-padding">

            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="" v-model="form.utilizzo">
            </el-input>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('auto.label.telepass') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-checkbox v-model="form.checkedTelepass" class="riva-header-checkbox"></el-checkbox>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('auto.label.navigator') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-checkbox v-model="form.checkedNavigator" class="riva-header-checkbox"></el-checkbox>
          </div>
        </div>

        <div v-if="form.statoAvanz !== '0'">
          <div class="elemento row row-custom">
            <div class="my-area col-24 no-padding">
              {{ $t('auto.label.segreteria') }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.modello !== '' && form.targa !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('auto.label.modelloAuto') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.modello }} - {{ form.targa }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.nrTelepass !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('auto.label.telepassNr') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.nrTelepass }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.notaSeg !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('auto.label.noteSegreteria') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.notaSeg }}
            </div>
          </div>
        </div>
      </el-form>

      <span slot="footer" class="" v-if="actionBar">
        <el-button class="WEB-button WEB-button-alternative" v-if="trasferta.terminata === 'T'" @click="close">{{
          $t('btn.close') }}</el-button>
        <el-button class="WEB-button WEB-button-alternative" v-if="trasferta.terminata !== 'T'" @click="close">{{
          $t('btn.annulla') }}</el-button>
        <el-button class="WEB-button WEB-button-primary" v-if="trasferta.terminata !== 'T'" @click="checkSave()">{{
          $t('btn.salva').toUpperCase()}}</el-button>
      </span>
      <span slot="footer" class="" v-else>
        <el-button class="WEB-button WEB-button-alternative" @click="close">{{ $t('btn.close') }}</el-button>
      </span>

    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'auto',
  props: ['trasferta', 'tbl_genSta', 'actionBar'],
  i18n: {
    messages: {
      it_IT: {
        auto: {
          label: {
            title: 'Auto Aziendale',
            giorno: 'Giorno',
            giorniPre: 'Giorni Prenotati',
            orario: 'Orario',
            note: 'Nota',
            telepass: 'Telepass',
            telepassNr: 'Numero Telepass',
            navigator: 'Navigatore GPS',
            modelloAuto: 'Modello Auto',
            ritiro: 'Luogo di Ritiro',
            utilizzo: 'Utilizzo',
            segreteria: 'Segreteria',
            noteSegreteria: 'Note Segreteria',
            allegati: 'Allegati',
            inizio: 'Inizio',
            fine: 'Fine',
            dataDal: 'Giorno Ritiro',
            dataAl: 'Giorno Riconsegna'
          },
          msg: {
            noData: 'Nessun Documento trovato',
            infoSel: 'Per aprire una singola prenotazione è necessario rimuove i flag di selezione multipla',
            noDocsSel: 'Nessun documento selezionato',
            datiObbligatoriMancanti: 'Dati obbligatori mancanti'
          }
        }
      },
      fr_FR: {
        auto: {
          label: {
            title: 'Réserver Voiture de société',
            giorno: 'Jour',
            giorniPre: 'Jours réservés',
            orario: 'Horaire',
            note: 'Notes',
            telepass: 'Boitier de péage',
            telepassNr: 'Numéro boit. de péage',
            navigator: 'Navigateur',
            modelloAuto: 'Modèle de voiture',
            ritiro: 'Départ',
            utilizzo: 'Utilisation',
            segreteria: 'Secrétaire',
            noteSegreteria: 'Annotations de la Secrétaire',
            allegati: 'Annexes',
            inizio: 'de',
            fine: 'à',
            dataDal: 'Jour de retrait',
            dataAl: 'Jour de retour'
          },
          msg: {
            noData: 'Aucun Réserver Voiture de société trouvé',
            infoSel: 'Pour ouvrir une seule reservation est nécessaire enlever l\'indicateur de sélection multiple',
            noDocsSel: 'Aucun document sélectionné',
            datiObbligatoriMancanti: 'Données obligatoires manquantes'
          }
        }
      },
      es_ES: {
        auto: {
          label: {
            title: 'Coche De La Sociedad',
            giorno: 'Día',
            giorniPre: 'Día de reserva',
            orario: 'Horas',
            note: 'Notes',
            telepass: 'Telepass',
            telepassNr: 'Número Telepass',
            navigator: 'Navegador GPS',
            modelloAuto: 'Modelo de coche',
            ritiro: 'Lugar de recogida',
            utilizzo: 'Uso',
            segreteria: 'Secretaria',
            noteSegreteria: 'Nota de la Secretaria',
            allegati: 'Adjuntos',
            inizio: 'de',
            fine: 'a',
            dataDal: 'Día de recogida',
            dataAl: 'Día de entrega'
          },
          msg: {
            noData: 'Sin informacion',
            infoSel: 'Para abrir una sola reserva es necesario eliminar los indicadores de selección múltiple.',
            noDocsSel: 'Ningún documento seleccionado',
            datiObbligatoriMancanti: 'Faltan datos obligatorios'
          }
        }
      },
      de_DE: {
        auto: {
          label: {
            title: 'Firmenfahrzeug',
            giorno: 'Tag',
            giorniPre: 'Tag der Reservierung',
            orario: 'Zeitraum',
            note: 'Notiz',
            telepass: 'Telepass',
            telepassNr: 'Telepassnummer',
            navigator: 'GPS-Navigator',
            modelloAuto: 'Auto',
            ritiro: 'Abholungsort',
            utilizzo: 'Benutzung',
            segreteria: 'Sekretariat',
            noteSegreteria: 'Notiz Sekretariat',
            allegati: 'Anlage',
            inizio: 'Uhr des Beginns',
            fine: 'Uhr des Endes',
            dataDal: 'Abholtag',
            dataAl: 'Rückgabetag'
          },
          msg: {
            noData: 'Kein Dokument gefunden',
            infoSel: 'Um eine einzelne Reservierung zu öffnen, müssen die Mehrfachauswahlflags entfernt werden',
            noDocsSel: 'Keine Dokumente ausgewählt',
            datiObbligatoriMancanti: 'Fehlende Pflichtangaben'
          }
        }
      },
      en_GB: {
        auto: {
          label: {
            title: 'Company Car',
            giorno: 'Day',
            giorniPre: 'Booked Days',
            orario: 'Time',
            note: 'Note',
            telepass: 'Telepass',
            telepassNr: 'Telepass Number',
            navigator: 'GPS Navigator',
            modelloAuto: 'Car Model',
            ritiro: 'Pickup Location',
            utilizzo: 'Usage',
            segreteria: 'Secretary',
            noteSegreteria: 'Secretary Notes',
            allegati: 'Attachments',
            inizio: 'Start',
            fine: 'End',
            dataDal: 'Pickup Day',
            dataAl: 'Return Day'
          },
          msg: {
            noData: 'No documents found',
            infoSel: 'To open a single booking, you must remove the multi-selection flags',
            noDocsSel: 'No documents selected',
            datiObbligatoriMancanti: 'Required data is missing'
          }
        }
      }
    }
  },
  data() {
    return {
      loading: false,
      auto: [],
      autoSel: [],
      indexCopy: '',
      currentPage: 1,
      pag_for: 8,
      pag_order: 'DD',
      nrPages: 0,
      nrItems: 0,
      showModal: false,
      form: {},
      tbl_mezzi: [],
      visibleInfo: false,
      validaAuto: true,
      picker_days: [],
      conformita: 'N'
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (date) {
      if (date !== '') {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    },
    formattaHours: function (hours) {
      if (hours !== '') {
        return hours.replace(',', ':')
      } else {
        return ' '
      }
    }
  },
  beforeMount: function () {
    this.loading = true
    this.loadAutoAzi()

    moment.locale(this.$i18n.locale)

    const dataDal = moment(this.trasferta.dataDal, 'YYYYMMDD')
    const dataAl = moment(this.trasferta.dataAl, 'YYYYMMDD')
    const numDays = dataAl.diff(dataDal, 'days') + 1

    this.picker_days = Array.from({ length: numDays }, (_, i) => {
      const giorno = dataDal.clone().add(i, 'days')
      return {
        value: giorno.format('YYYYMMDD'),
        label: giorno.format('dddd Do MMM YYYY')
      }
    })
  },
  mounted: function () {
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.copia) {
        return 'row-copy'
      } else if (row.sel) {
        return 'row-sel'
      }
      return ''
    },
    loadAutoAzi: function () {
      this.loading = true
      this.$set(this, 'auto', [])
      console.log(this.trasferta)

      this.$http.get('trasferte/' + this.$store.state.country + '/autoAzi', {
        params: {
          idTrasferta: this.trasferta.idTrasferta,
          pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
          pag_from: this.currentPage,
          pag_for: this.pag_for,
          pag_order: this.pag_order,
          dataDal: this.trasferta.dataDal,
          dataAl: this.trasferta.dataAl,
          vista: this.actionBar ? '' : 'R'
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.auto = response.body.data
            if (this.currentPage === 1) {
              const pages = response.body.attrib && response.body.attrib.pages
              const size =  response.body.attrib && response.body.attrib.size
              const conformita =  response.body.attrib && response.body.attrib.conformita
              this.$set(this, 'nrPages', pages ? parseInt(pages) : 1)
              this.$set(this, 'nrItems', size ? parseInt(size) : 0)
              this.$set(this, 'conformita', conformita ? conformita : 'N')
            }
          } else {
            this.$set(this, 'nrPages', 0)
            this.$set(this, 'nrItems', 0)
          }
          this.loading = false
        })
    },
    setConformita: function () {
      let data = {
        idTrasferta: this.trasferta.idTrasferta,
        operazione: "Y"
      }
      this.$http.post('trasferte/' + this.country + '/conformitaauto', data, {
        params: {
          codLang: sessionStorage.getItem('codLang')
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.conformita = 'Y'
            this.validaAuto = true
            this.$set(this, 'form', {})
            //this.$set(this.form, 'giorno', this.trasferta.dataDal)
            this.$set(this.form, 'dataDal', this.trasferta.dataDal)
            this.$set(this.form, 'dataAl', this.trasferta.dataAl)
            this.$set(this.form, 'checkedTelepass', false)
            this.$set(this.form, 'checkedNavigator', false)
            this.form.id = ''
            this.form.idTrasferta = this.trasferta.idTrasferta
            this.form.statoAvanz = '0'
            this.showModal = true
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    add: function () {
      if (this.conformita !== 'Y') {
        let _this = this
        this.$confirm(
          this.$i18n.t('trasferte.conformita.testo'),
          this.$i18n.t('trasferte.conformita.titolo'),
          {
            confirmButtonText: this.$i18n.t('btn.conferma'),
            cancelButtonText: this.$i18n.t('btn.annulla'),
            dangerouslyUseHTMLString: true,
            customClass: 'my-custom-confirm',
            callback: function (action) {
              if (action === 'confirm') {
                _this.setConformita()
              } else {
                _this.$message({
                  showClose: true,
                  message: _this.$i18n.t('trasferte.conformita.abort'),
                  type: 'info',
                  duration: process.env.duration
                })
              }
            }
          }
        )
      } else {
        this.validaAuto = true
        this.$set(this, 'form', {})
        this.$set(this.form, 'dataDal', this.trasferta.dataDal)
        this.$set(this.form, 'dataAl', this.trasferta.dataAl)
        this.$set(this.form, 'checkedTelepass', false)
        this.$set(this.form, 'checkedNavigator', false)
        this.form.id = ''
        this.form.idTrasferta = this.trasferta.idTrasferta
        this.form.statoAvanz = '0'
        this.showModal = true
      }
    },
    open: function (row, event, column) {
      this.validaAuto = true
      this.$set(this, 'form', {})
      this.form.id = row.id
      this.form.statoAvanz = row.statoAvanz
      this.$set(this.form, 'giorno', row.giorno)
      this.$set(this.form, 'oraDal', moment(row.oraDal, 'HH,mm').format('HH:mm'))
      this.$set(this.form, 'oraAl', moment(row.oraAl, 'HH,mm').format('HH:mm'))
      this.$set(this.form, 'luogoRitiro', row.luogoRitiro)
      this.$set(this.form, 'utilizzo', row.utilizzo.split("\\n").join("\n"))
      this.$set(this.form, 'checkedTelepass', row.telepass === '1' ? true : false)
      this.$set(this.form, 'checkedNavigator', row.navigatore === '1' ? true : false)

      //Segreteria
      this.form.modello = row.modello
      this.form.targa = row.targa
      this.form.nrTelepass = row.nrTelepass
      this.form.notaSeg = row.notaSeg
      this.showModal = true
    },
    close: function () {
      this.showModal = false
    },
    checkSave: function () {
      this.validaAuto = true
      if (this.form.oraDal === null || this.form.oraDal === undefined) {
        this.validaAuto = false
      }
      if (this.form.oraAl === null || this.form.oraAl === undefined) {
        this.validaAuto = false
      }
      if (this.form.luogoRitiro === '' || this.form.luogoRitiro === undefined) {
        this.validaAuto = false
      }

      if (this.validaAuto) {
        this.save()
      } else {
        this.$message.error(this.$i18n.t('auto.msg.datiObbligatoriMancanti'))
      }
    },
    save: function () {
      this.loading = true;

      let idPrenotazioni = [];

      if (this.form.id !== '') {
        idPrenotazioni.push({
          giorno: this.form.giorno,
          id: this.form.id
        });
      } else {
        const dataDal = moment(this.form.dataDal, 'YYYYMMDD');
        const dataAl = moment(this.form.dataAl, 'YYYYMMDD');
        const numDays = dataAl.diff(dataDal, 'days') + 1;

        for (let i = 0; i < numDays; i++) {
          idPrenotazioni.push({
            giorno: moment(dataDal).add(i, 'days').format('YYYYMMDD'),
            id: ''
          });
        }
      }

      const obj = {
        idTrasferta: this.trasferta.idTrasferta,
        oraDal: moment(this.form.oraDal, 'HH:mm').format('HH.mm.ss'),
        oraAl: moment(this.form.oraAl, 'HH:mm').format('HH.mm.ss'),
        luogoRitiro: this.form.luogoRitiro,
        utilizzo: this.form.utilizzo,
        navigatore: this.form.checkedNavigator ? '1' : '0',
        telepass: this.form.checkedTelepass ? '1' : '0',
        idPrenotazioni: JSON.stringify(idPrenotazioni),
        statoAvanz: this.form.statoAvanz
      };

      this.$http.post(`trasferte/${this.$store.state.country}/autoAzi`, obj)
        .then(response => {
          const { rc, msg } = response.body;

          this.$message({
            showClose: true,
            message: msg[0].msgTxt,
            type: rc === 0 ? 'success' : 'error',
            duration: process.env.duration
          });

          if (rc === 0) {
            this.loadAutoAzi();
            this.showModal = false;
          }

          this.loading = false;
        });
    },
    del: function (row) {
      this.loading = true
      this.$http.delete('trasferte/' + this.$store.state.country + '/autoAzi/' + row.idTrasferta + '/' + row.id)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loadAutoAzi()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    changePage: function (page) {
      this.currentPage = page
      this.loadAutoAzi()
    },
    isDisabled: function () {
      if (this.trasferta.terminata === 'T' || this.form.id != '') {
        return true
      } else {
        return false
      }
    },
    enableAction: function (row) {
      let statoTrasferta = this.trasferta.statoAvanz
      if (this.trasferta.terminata === 'T') {
        return false
      } else if (statoTrasferta === '0' || statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '5') {
        return true
      } else {
        return false
      }
    },
    getStatoIcon_dett: function (stato) {
      switch (stato) {
        case '0':
        case '1':
        case '2':
        case '3':
        case '4':
          return 'riv-circle'
        default:
          return ''
      }
    },
    getStatoClass_dett: function (stato) {
      switch (stato) {
        case '0':
          return 'status-saved'
        case '1':
          return 'status-send'
        case '2':
          return 'status-rejected'
        case '3':
          return 'status-approved'
        case '4':
          return 'status-send'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.auto {
  .action {
    height: 53px;
    text-align: right;
    padding-top: 10px;
  }

  height: 100%;
  //min-width: 1250px;
  max-width: 100%;

  .top-block {
    background-color: white;
    width: 100%;
    z-index: 1;

    .resp-header {
      .set-font(@color: #606266; @size: 14px);
      //border: solid 1px darkgray;
      //margin: 15px 15px 15px 15px;
      //background-color: #f4f5f6;
      padding: 15px 19px 20px 19px;
      height: 95px;

      .mail {
        margin-bottom: 10px;
        padding: 0;
        text-align: left;
      }

      .search {
        padding: 0 !important;
        float: left;
        width: 430px;
        position: relative;

        .select {
          float: left;
          text-align: left;
          margin-right: 10px;

          .el-date-editor {
            width: 160px;

            .el-input__inner {
              border: none;
              border-bottom: 1px solid #e7e7e7;
              padding-right: 0;
              padding-left: 20px;
              height: 22px;
              line-height: 22px;
            }

            .el-input__prefix {
              line-height: 22px;
              left: -5px;

              .el-input__icon {
                line-height: 22px;
              }
            }

            .el-input__suffix {
              line-height: 22px;

              //left: -5px;
              .el-input__icon {
                line-height: 22px;
              }
            }
          }
        }
      }

      .status {
        position: relative;
        float: left;
        color: #606266;
      }
    }

    .table-header {
      .set-font(@size: 12px; @weight: bold);
      background-color: white;
      border-bottom: 1px solid @greenRiva;
      border-top: 1px solid @greenRiva;
      line-height: 38px;
      background-color: @white;
      text-align: left;

      //color: white;
      //margin-left: 15px;
      //margin-right: 15px;
      span {
        display: inline-block;
        text-align: center;
        //text-transform: uppercase;
      }

      .widthSelect {
        display: inline-block;
      }
    }
  }

  .el-table {

    .el-table__body {
      tbody {
        tr {
          &.expanded {
            background-color: #e7e7e7;

            td {
              background-color: #e7e7e7 !important;
            }
          }

          &.row-copy {
            background-color: #b5d2d0
          }

          &.row-copy:hover>td {
            background-color: #b5d2d0 !important;
          }

          &.row-sel {
            background-color: #eaeaea
          }

          &.row-sel:hover>td {
            background-color: #eaeaea !important;
          }

          &.hover-row {
            td {
              background-color: @white;
            }
          }

          &.single {
            .el-table__expand-icon {
              display: none;
            }
          }
        }
      }
    }
  }

  .el-checkbox {
    margin-bottom: 0px;

    //margin-top: 10px;
    .el-checkbox__inner {
      border-radius: 0px;
    }

    &.is-checked {
      .el-checkbox__inner {
        background-color: @greenRiva;
        border-color: @greenRiva;
      }
    }
  }
}

.row {
  &.row-error {
    .my-label {
      color: red !important;
    }

    .my-input {
      border: 1px solid red !important;
    }
  }
}

.my-custom-confirm {
  width: 600px;
  max-width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/Trasferte/AutoAziendali.vue